var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native-web");
var _simpleMarkdown = _interopRequireDefault(require("simple-markdown"));
var _styles = require("./styles");
var _utils = require("../../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports["default"] = Object.assign({}, _simpleMarkdown["default"].defaultRules.list, {
  react: function react(node, output, state) {
    var _useStyles = (0, _styles.useStyles)({
        sharedStyles: state.sharedStyles
      }),
      styles = _useStyles.styles;
    return (0, _jsxRuntime.jsx)(_reactNative.View, {
      accessibilityRole: (0, _utils.WebAccessibilityRole)('list'),
      style: [styles.list, state.containerStyle],
      children: node.items.map(function (item, i) {
        return (0, _jsxRuntime.jsxs)(_reactNative.View, {
          accessibilityRole: (0, _utils.WebAccessibilityRole)('listitem'),
          style: styles.listItem,
          children: [node.ordered && (0, _jsxRuntime.jsx)(_reactNative.Text, {
            textBreakStrategy: "simple",
            style: styles.number,
            children: "".concat(i + 1, ")")
          }), !node.ordered && (0, _jsxRuntime.jsx)(_reactNative.Text, {
            textBreakStrategy: "simple",
            style: styles.bullet,
            children: "\u2022"
          }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
            textBreakStrategy: "simple",
            style: styles.text,
            children: output(item, state)
          })]
        }, "".concat(state.key, "__").concat(i));
      })
    }, state.key);
  }
});